import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAssets } from "../services/api";

export const getAssets = createAsyncThunk("assets/fetchAssets", async () => {
  const response = await fetchAssets();
  return response;
});

const assetsSlice = createSlice({
  name: "assets",
  initialState: { data: [], status: "idle" },
  extraReducers: (builder) => {
    builder
      .addCase(getAssets.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAssets.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getAssets.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default assetsSlice.reducer;

